/** Shared Framer Motion variants and transition presets. */

export const viewport = {
  once: true,
  amount: 0.2,
};

export const premiumEase = [0.22, 1, 0.36, 1];

export const defaultTransition = {
  duration: 0.6,
  ease: premiumEase,
};

export const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

export const fadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
};

export const fadeRight = {
  hidden: { opacity: 0, x: -24 },
  visible: { opacity: 1, x: 0 },
};

export const fadeLeft = {
  hidden: { opacity: 0, x: 24 },
  visible: { opacity: 1, x: 0 },
};

export const scaleIn = {
  hidden: { opacity: 0, scale: 0.97 },
  visible: { opacity: 1, scale: 1 },
};

export const staggerContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.04,
    },
  },
};

export const staggerItem = fadeUp;

export const imageReveal = {
  hidden: { opacity: 0, scale: 0.98 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.7, ease: premiumEase },
  },
};

export const hoverCard = {
  rest: { y: 0, scale: 1 },
  hover: { y: -8, scale: 1.01 },
};

export const hoverButton = {
  rest: { y: 0, scale: 1 },
  hover: { y: -2, scale: 1.03 },
  tap: { scale: 0.98 },
};

export const hoverTransition = {
  duration: 0.25,
  ease: premiumEase,
};

/** Maps legacy AOS animation names to variant keys. */
export const aosVariantMap = {
  "fade-up": "fadeUp",
  "fade-in": "fadeIn",
  "fade-right": "fadeRight",
  "fade-left": "fadeLeft",
  "zoom-in": "scaleIn",
};

export const variants = {
  fadeUp,
  fadeIn,
  fadeRight,
  fadeLeft,
  scaleIn,
  staggerContainer,
  staggerItem,
  imageReveal,
  hoverCard,
  hoverButton,
};

/**
 * @param {number} delayMs - delay in milliseconds (AOS-compatible)
 * @param {number} [duration=0.6]
 */
export function getTransition(delayMs = 0, duration = defaultTransition.duration) {
  return {
    duration,
    ease: premiumEase,
    delay: delayMs / 1000,
  };
}

/**
 * Resolve a variant key from an AOS-style string or variant name.
 * @param {string} value
 * @returns {keyof typeof variants}
 */
export function resolveVariant(value) {
  if (!value) return "fadeUp";
  if (typeof value !== "string") return "fadeUp";
  const normalized = value.replace(/['"]/g, "").trim();
  return aosVariantMap[normalized] || normalized;
}
